import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import Chart from 'chart.js/auto';
import Navbar from '../components/Navbar';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const TicketsArea = () => {
  
   const obtenerFechaLocal = () => {
    const hoy = new Date();
    hoy.setMinutes(hoy.getMinutes() - hoy.getTimezoneOffset()); // Ajusta al huso horario local
    return hoy.toISOString().slice(0, 10);
  };
    const [fechaDesde, setFechaDesde] = useState(obtenerFechaLocal());
    const [fechaHasta, setFechaHasta] = useState(obtenerFechaLocal());
  const [resumen, setResumen] = useState([]);
  const chartRef = useRef(null);

  const obtenerResumen = () => {
    axios
      .get(`https://garibcasinos.com/api/tickets-por-area.php?desde=${fechaDesde}&hasta=${fechaHasta}`)
      .then(res => setResumen(res.data))
      .catch(err => console.error(err));
  };

  useEffect(() => {
    obtenerResumen();
  }, [fechaDesde, fechaHasta]);

  useEffect(() => {
    if (resumen.length) {
      if (chartRef.current) {
        chartRef.current.destroy();
      }

      const ctx = document.getElementById('chartArea').getContext('2d');
      chartRef.current = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: resumen.map(r => r.area),
          datasets: [{
            label: 'Cantidad de Tickets por Área',
            data: resumen.map(r => r.total),
            backgroundColor: 'rgba(255, 99, 132, 0.6)'
          }]
        },
        options: {
          scales: {
            x: { title: { display: true, text: 'Área' } },
            y: { title: { display: true, text: 'Cantidad' }, beginAtZero: true }
          }
        }
      });
    }
  }, [resumen]);

  const exportarExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(resumen);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Tickets por Área");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, `tickets_por_area_${fechaDesde}_a_${fechaHasta}.xlsx`);
  };

  return (
    <>
      <section className="section">
        <div className="container">
          <h1 className="title">Tickets por Área</h1>
          <div className="columns is-multiline is-align-items-end">
            <div className="column is-narrow">
              <label className="label">Desde:</label>
              <input type="date" className="input" value={fechaDesde} onChange={(e) => setFechaDesde(e.target.value)} />
            </div>
            <div className="column is-narrow">
              <label className="label">Hasta:</label>
              <input type="date" className="input" value={fechaHasta} onChange={(e) => setFechaHasta(e.target.value)} />
            </div>
            <div className="column is-narrow">
              <button className="button is-info mt-5" onClick={exportarExcel}>📁 Exportar a Excel</button>
            </div>
          </div>

          <canvas id="chartArea" height="100" className="mb-5"></canvas>

          <table className="table is-fullwidth is-striped">
            <thead>
              <tr>
                <th>Área</th>
                <th>Cantidad de Tickets</th>
              </tr>
            </thead>
            <tbody>
              {resumen.length > 0 ? resumen.map((r, index) => (
                <tr key={index}>
                  <td>{r.area}</td>
                  <td>{r.total}</td>
                </tr>
              )) : (
                <tr>
                  <td colSpan="2" className="has-text-centered">No hay datos en el rango seleccionado</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
};

export default TicketsArea;
